"use strict";

var _$isAbsoluteURL_20 = function (url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlzQWJzb2x1dGVVUkwuanMiXSwibmFtZXMiOlsibW9kdWxlIiwidXJsIiwidGVzdCJdLCJtYXBwaW5ncyI6IkFBQUEsWUFBQSxDQUFBOztBQVFBQSxzQkFBQUEsR0FBaUIsVUFBdUJDLEdBQXZCLEVBQXVCQTtFQUl0QyxPQUFPLCtCQUFBLENBQWdDQyxJQUFoQyxDQUFxQ0QsR0FBckMsQ0FBUCxDQUFBO0NBSkZELENBQUFBIiwic291cmNlc0NvbnRlbnQiOltudWxsXX0=